<div class="configuration-list-container">
  <section class="feature-page">
    <app-page-header title="Ministerios" subtitle="Gestiona los ministerios del sistema" icon="volunteer_activism">
    </app-page-header>

    <div class="feature-page__content">
      <mat-card class="table-surface-card">
        <mat-card-content>
          <app-table-surface
              [columns]="columns"
              [data]="tableData"
              [isLoading]="isLoading"
              [enableDragDrop]="enableDragDrop"
              [cellTemplate]="cellTemplate"
              [savingCell]="savingCell"
              [activeFilters]="activeFilterChips"
              tableId="ministry-list"
              [enableSearch]="true"
              searchPlaceholder="Buscar ministerio..."
              [enableFilter]="true"
              filterMenuTitle="Estado"
              [filterOptions]="statusFilterOptions"
              [enableColumnVisibility]="true"
              [enableDensity]="true"
              primaryActionLabel="Nuevo"
              (searchChange)="onToolbarSearch($event)"
              (filterRemove)="onFilterRemove($event)"
              (filterOptionSelect)="onFilterOptionSelect($event)"
              (rowReorder)="onMinistryReorder($event)"
              (cellEditSave)="onCellEditSave($event)"
              (primaryActionClick)="createNew()">
          </app-table-surface>

          <!-- Template para renderizar celdas personalizadas -->
          <ng-template #cellTemplate let-column="column" let-row="row">
            <span *ngIf="column === 'name'">{{ row.name }}</span>
            <mat-slide-toggle *ngIf="column === 'isActive'" class="status-toggle" [checked]="row.isActive"
              (click)="$event.stopPropagation()" (change)="onStatusChange(row, $event.checked)" aria-label="Cambiar estado">
            </mat-slide-toggle>
            <div *ngIf="column === 'actions'" class="actions-cell">
              <button mat-icon-button matTooltip="Editar" (click)="$event.stopPropagation(); editMinistry(row)">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button matTooltip="Eliminar" (click)="$event.stopPropagation(); deleteMinistry(row)">
                <mat-icon color="warn">delete</mat-icon>
              </button>
            </div>
          </ng-template>
        </mat-card-content>
      </mat-card>
    </div>
  </section>
</div>
